import styled from '@emotion/styled'

import { textEllipsis, typo } from '~/@common/styles'
import { Card } from '~/@common/ui/(Card)'
import Table from '~/@common/ui/Table/Table'

export const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
  `,

  // ─── PC 테이블 ───
  NoticeTable: styled(Table)`
    flex: 1;
    min-height: 0;
    tbody tr {
      height: 70px;
    }

    .title-cell {
      justify-content: flex-start;
      padding-left: 20px;

      .title-text {
        ${textEllipsis(2)}
      }

      strong {
        font-weight: 700;
      }
    }
  `,

  // ─── MO 카드 ───
  CardList: styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    gap: 10px;
    overflow: auto;
  `,

  Card: styled(Card)`
    flex-shrink: 0;
    padding: 14px 20px;
    cursor: pointer;

    &:active {
      background-color: var(--Colors-Gray-100);
    }
  `,

  CardMeta: styled.div`
    ${typo.caption01}
    font-weight: 700;
    color: var(--Colors-Gray-700);
    margin-bottom: 6px;
  `,

  CardTitle: styled.p`
    ${typo.body02}
    color: var(--Colors-Gray-900);
    ${textEllipsis(2)}
  `,

  Empty: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 300px;
    ${typo.body02}
    color: var(--Colors-Gray-500);
  `,
}
